





































































































































import Vue from "vue";
// import TravelFeature from "@/components/user_portal_components/TravelFeature.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "SingleTravelFeature",
  components: {
    // TravelFeature,
  },
  data() {
    return {
      newItem: {
        link: "",
        linkLabel: "More info",
        choices: [],
        parentOnly: true,
        staffOnly: true,
        section_id: 0,
        text: "",
      },
      is_staff: false,
      blockIndex: undefined,
      updatedCategory: {},
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    category: {
      type: Number,
      required: true,
    },
    section: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    queryParams: {
      type: String,
    },
  },
  watch: {
    newItem: {
      handler: function (newVal) {
        const updatedCategory = JSON.parse(JSON.stringify(this.section));
        if (this.blockIndex > -1) {
          updatedCategory.blocks[this.blockIndex] = this.newItem;
        } else {
          updatedCategory.blocks = [
            ...updatedCategory.blocks,
            {
              ...this.newItem,
              id: 879879879,
              parentOnly: Number(this.newItem.parentOnly),
              staffOnly: Number(this.newItem.staffOnly),
            },
          ];
        }
        this.updatedCategory = JSON.parse(JSON.stringify(updatedCategory));
        // this.$refs.refObj.openAction();
      },
      deep: true,
    },
  },
  methods: {
    save() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          ApiService.generalApi
            .saveTravelFeature(this.newItem, this.queryParams)
            .then((resp) => {
              this.$notify.success({
                title: "Success",
                message: "Saved",
              });
              this.$emit("close");
            });
        } else {
          return false;
        }
      });
    },
    deleteItem(id) {
      ApiService.generalApi.deleteTravelFeature(id).then((itm) => {
        this.$notify.success({
          title: "Success",
          message: "You have deleted item",
        });
        this.$emit("close");
      });
    },
    closeModal() {
      this.close();
    },
  },
  mounted() {
    if (this.item.id) {
      this.newItem = Object.assign({}, this.item);
      if (this.item.staffOnly == 0 && this.item.parentOnly == 0) {
        this.newItem.staffOnly = true;
        this.newItem.parentOnly = true;
      } else if (this.item.staffOnly == 1) {
        this.newItem.staffOnly = true;
      } else if (this.item.parentOnly == 1) {
        this.newItem.parentOnly = true;
      }

      this.blockIndex = this.section.blocks.findIndex(
        (itm) => itm.id == this.item.id
      );
    } else {
      this.newItem.section_id = this.category;
    }
    this.updatedCategory = JSON.parse(JSON.stringify(this.section));
    this.$forceUpdate();
  },
});
